import { Checkbox, FormControlLabel, Grid, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { MessageUsersTemplate } from '../../../../hooks/useMessageUsersTextTemplates';
import { OnlyFansSubscriber } from '../../../../hooks/useSubscriber';
import MessageUsersFormEditorTemplateLoadDialog from './MessageUsersFormEditorTemplateLoadDialog';

type Props = {
    subscriber: OnlyFansSubscriber;
    saveTemplate: boolean;
    setSaveTemplate: (saveTemplate: boolean) => void;
    saveTemplateName: string;
    setSaveTemplateName: (templateName: string) => void;
    handleLoadTemplate: (template: MessageUsersTemplate) => void;
    externallyOpenLoadTemplateDialog?: boolean;
    setExternallyOpenLoadTemplateDialog?: (open: boolean) => void;
    disabled?: boolean;
    showSave?: boolean;
};

const MessageUsersFormEditorTemplateSave = (props: Props) => {
    const {
        subscriber,
        saveTemplate,
        setSaveTemplate,
        saveTemplateName: templateName,
        setSaveTemplateName: setTemplateName,
        handleLoadTemplate,
        externallyOpenLoadTemplateDialog,
        setExternallyOpenLoadTemplateDialog,
        disabled,
        showSave = true,
    } = props;

    const [loadTemplateDialogOpen, setLoadTemplateDialogOpen] = useState<boolean>(false);

    // Sync external control of load template dialog if provided
    if (externallyOpenLoadTemplateDialog !== undefined && setExternallyOpenLoadTemplateDialog !== undefined) {
        if (externallyOpenLoadTemplateDialog !== loadTemplateDialogOpen) {
            setLoadTemplateDialogOpen(externallyOpenLoadTemplateDialog);
        }
    }

    useEffect(() => {
        if (setExternallyOpenLoadTemplateDialog) {
            setExternallyOpenLoadTemplateDialog(loadTemplateDialogOpen);
        }
    }, [loadTemplateDialogOpen, setExternallyOpenLoadTemplateDialog]);

    return (
        <Grid container spacing={1} alignItems={'center'}>
            {showSave && (
                <Grid item xs={12} sm="auto">
                    <FormControlLabel
                        control={<Checkbox size="medium" checked={saveTemplate} onChange={() => setSaveTemplate(!saveTemplate)} />}
                        label="Save as Caption"
                        disabled={disabled}
                    />
                </Grid>
            )}
            <Grid item xs={12} sm>
                <Stack direction="row" spacing={1} alignItems="center">
                    {showSave && (
                        <TextField
                            label="Caption Name"
                            value={templateName}
                            onChange={e => setTemplateName(e.currentTarget.value)}
                            disabled={!saveTemplate || disabled}
                            fullWidth
                            error={saveTemplate && templateName.trim().length === 0}
                            helperText={saveTemplate && templateName.trim().length === 0 ? 'Template name is required' : ''}
                        />
                    )}
                    <MessageUsersFormEditorTemplateLoadDialog
                        subscriber={subscriber}
                        handleLoadTemplate={handleLoadTemplate}
                        loadTemplateDialogOpen={loadTemplateDialogOpen}
                        setLoadTemplateDialogOpen={newState => {
                            setLoadTemplateDialogOpen(newState);

                            if (setExternallyOpenLoadTemplateDialog) {
                                setExternallyOpenLoadTemplateDialog(newState);
                            }
                        }}
                    />
                </Stack>
            </Grid>
        </Grid>
    );
};

export default MessageUsersFormEditorTemplateSave;
